export default function validateZoomUrl(url) {
  const results = url.match(
    /https:\/\/[\w-]*\.?zoom.us\/(webinar\/register)\/[\d\w?=-]+/
  )

  if (results?.length) {
    return results[0]
  }

  return false
}
